import { Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import CheckListFBYRadioItems from "../../../../../blocks/FormItems/CheckListFBYRadioItems";
import {
  dailyActivityDependenceOptions,
  dailyActivityOptions,
} from "../../../Options/functionalAsessmentOptions";
import { hexToRgba } from "../../../../../helpers/utility";
import {theme} from "antd";
const DailyActivities = ({ context, form }) => {
  const { token } = theme.useToken();
  const { formData } = useContext(context);
  const [checkboxes, setCheckBoxes] = useState([]);
  useEffect(() => {
    const initialCheckboxes = dailyActivityOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] =
        formData?.functional_status?.daily_activities?.[checkbox.value] ||
        false;
      return acc;
    }, {});
    setCheckBoxes(initialCheckboxes);
  }, [formData]);
  return (
    <>
      <Typography>Daily Activities</Typography>
      <div
                  className="subsection-card"
                  style={{
                    borderLeft: `2px solid ${hexToRgba(token.colorPrimaryHover, 0.2)}`,
                    background: "transparent",
                    marginTop: "8px",
                    padding: "8px 12px",
                    borderRadius: "8px",
                  }}
                >
        <CheckListFBYRadioItems
          checkBoxOptions={dailyActivityOptions}
          radioOptions={dailyActivityDependenceOptions}
          checkboxes={checkboxes}
          setCheckboxes={setCheckBoxes}
          keyChain={"daily_activities"}
          form={form}
        />
      </div>
    </>
  );
};

export default DailyActivities;
